export const decrement = (n: number, min: number, reset: number) => {
  return n - 1 < min ? reset : n - 1
}

export const increment = (n: number, max: number, reset = 0) => {
  return n + 1 > max ? reset : n + 1
}
